import { ApiService } from './../../api.service';
import { Component, OnInit } from '@angular/core';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-demographics',
  templateUrl: './demographics.component.html',
  styleUrls: ['./demographics.component.css']
})
export class DemographicsComponent implements OnInit {
  public title : string;

  genders = [{text:"Female"},{text:"Male"}];
  debug = "";

  constructor(public api : ApiService) { }

  ngOnInit() {
  }

  get demographics(){
    return this.api.session.currentCriteria.patientDemographics;
  }

  clearCurrent(){
    this.api.session.currentCriteria.patientDemographics = MyUtility.deepCopy(this.api.originalCriteria.patientDemographics);
  }
}
